<template>
  <div class="col auto dropDownAnalisis">
    <multiselect
      deselect-label
      select-label
      open-direction="bottom"
      track-by="id"
      label="title"
      :options="acResult"
      :multiple="false"
      placeholder="Busque por analista"
      :show-no-results="false"
      @search-change="searchJournalist"
      @select="selectOpt"
    >
      <template slot="noOptions">
        <span v-html="'Digite el nombre del analista'"></span>
      </template>
      <template slot="option" slot-scope="props">
        <img :src="props.option.newImage" :alt="props.option.rawTitle"
        />
        <span v-html="props.option.title"></span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import axios from "axios";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  props: {
    ctx: String,
  },
  methods: {
    searchJournalist: debounce(function (topic) {
      const _self = this;
      if (topic) {
        const params = {
          term: topic,
        };
        if (_self.ctx) {
          params.ctx = _self.ctx;
        }
        axios.get("/api/analysis/ac", { params }).then(function (d) {
          _self.acResult = d.data;
        });
      } else {
        this.clean();
      }
    }, 250),
    selectOpt: function (opt) {
      window.location.href = "/redirect/" + opt.acType + "/" + opt.id;
    },
    clean: function () {
      this.acResult = [];
    },
  },
  data: function () {
    return {
      acResult: [],
    };
  },
};
</script>
